export const ORG_KEY = 'ops_org';

export const ORG_META = {
  thrive: { key: 'thrive', name: 'Thrive', sub: 'Ops Hub', full: 'Thrive Speech Therapy', short: 'Thrive',
    logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_pediatric-dispatch/artifacts/ocaqpxqe___circle%20logo_dark%20purple.jpg' },
  ludo: { key: 'ludo', name: 'Ludo', sub: 'Ops Hub', full: 'Ludo ABA',
    logo: 'https://customer-assets-eiarnc6j.emergentagent.net/job_b1a1b908-c6f4-4002-b0a6-ade01782df2b/artifacts/94a8114fcdc3d511_LUDO.webp' },
};

// Paths that exist in the Ludo workspace; anything else falls back to the pipeline.
export const LUDO_PATHS = ['/ludo', '/referral-links', '/inquiries', '/vault', '/users', '/help', '/feedback'];

export function getOrg() {
  try {
    const q = new URLSearchParams(window.location.search).get('org');
    if (q === 'ludo' || q === 'thrive') return q;
    return localStorage.getItem(ORG_KEY) === 'ludo' ? 'ludo' : 'thrive';
  } catch { return 'thrive'; }
}

export function setOrg(org) {
  localStorage.setItem(ORG_KEY, org === 'ludo' ? 'ludo' : 'thrive');
}
